import React from 'react'
import { MemoryRouter, UNSAFE_LocationContext } from 'react-router'
import type { DepositFlow } from '@mobi/account/Areas/Deposit/typings/types'
import { layering } from '@mobi/component-library/Foundations'
import { OverlayOpen } from '@core/Components/Overlay'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'
import { appHistory } from '@core/Utils/routing/history'
import { Deposit, type DepositProps } from './Deposit'

export const openDepositModal = (flow: DepositFlow) =>
  openDeposit({
    asModal: true,
    flow,
  })

export function openDeposit(props?: DepositProps) {
  if (props?.asModal) {
    // `props` can no longer be undefined here as `asModal` must be `true`
    OverlayOpen({
      Component: () => (
        // in  RR's infinite genius, they made it so you cant nest routers because 'we said so'
        // unfortunately the way deposit is built, it cannot be tied to the parent routing context
        // and still work as a page and nested modal, so we use delete to context and make it work in
        // its own memory router context
        // https://github.com/remix-run/react-router/issues/7375#issuecomment-975431736
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-pascal-case
        <UNSAFE_LocationContext.Provider value={null as any}>
          <MemoryRouter>
            <Deposit asModal={props.asModal} flow={props.flow} />
          </MemoryRouter>
        </UNSAFE_LocationContext.Provider>
      ),
      layer: layering.modalOverlayHigh,
    })
  } else {
    if (window.location.pathname !== '/deposit') {
      appHistory.push('/deposit')
    }
  }

  trackEvent(keys.setPageVisit, { customURL: '/', pageTitle: 'DEPOSIT' })
}
